export default "/images/5c75eb947c168fdb0e27f08934feac8c.jpg";